var AddCandidate = /** @class */ (function () {
    function AddCandidate() {
        this.firstName;
        this.lastName;
        this.emailId;
        this.phoneNumber;
        this.companyId;
        this.jobId;
    }
    return AddCandidate;
}());
export { AddCandidate };
//# sourceMappingURL=addCandidate.js.map